/*
	Traducere de Ovidiu Lixandru: http://www.madball.ro
 */

const locale: IGanttLocale = {
	date: {
		month_full: ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "November", "December"],
		month_short: ["Ian", "Feb", "Mar", "Apr", "Mai", "Iun", "Iul", "Aug", "Sep", "Oct", "Nov", "Dec"],
		day_full: ["Duminica", "Luni", "Marti", "Miercuri", "Joi", "Vineri", "Sambata"],
		day_short: ["Du", "Lu", "Ma", "Mi", "Jo", "Vi", "Sa"]
	},
	labels: {
		new_task: "Sarcina noua",
		icon_save: "Salveaza",
		icon_cancel: "Anuleaza",
		icon_details: "Detalii",
		icon_edit: "Editeaza",
		icon_delete: "Sterge",
		confirm_closing: "Schimbarile nu vor fi salvate, esti sigur?",// Your changes will be lost, are your sure ?
		confirm_deleting: "Evenimentul va fi sters permanent, esti sigur?",
		section_description: "Descriere",
		section_time: "Interval",
		section_type: "Type",
		/* grid columns */

		column_wbs: "WBS",
		column_text: "Task name",
		column_start_date: "Start time",
		column_duration: "Duration",
		column_add: "",

		/* link confirmation */
		link: "Link",
		confirm_link_deleting: "will be deleted",
		link_start: " (start)",
		link_end: " (end)",

		type_task: "Task",
		type_project: "Project",
		type_milestone: "Milestone",


		minutes: "Minutes",
		hours: "Hours",
		days: "Days",
		weeks: "Week",
		months: "Months",
		years: "Years",

		/* message popup */
		message_ok: "OK",
		message_cancel: "Anuleaza",

		/* constraints */
		section_constraint: "Constraint",
		constraint_type: "Constraint type",
		constraint_date: "Constraint date",
		asap: "As Soon As Possible",
		alap: "As Late As Possible",
		snet: "Start No Earlier Than",
		snlt: "Start No Later Than",
		fnet: "Finish No Earlier Than",
		fnlt: "Finish No Later Than",
		mso: "Must Start On",
		mfo: "Must Finish On",

		/* resource control */
		resources_filter_placeholder: "type to filter",
		resources_filter_label: "hide empty"
	}
};

export default locale;